import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { useFormContext } from "react-hook-form";
import { Textarea } from "@/components/ui/textarea";

export const Step7Message = () => {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name="message"
      render={({ field }) => (
        <FormItem className="space-y-6 w-full">
          <div className="flex flex-col gap-1 mb-2">
            <h1 className="font-h2 text-dark-blue">Un message pour le chef ?</h1>
            <p className="font-p text-muted-foreground">
              Informations supplémentaires, ambiance souhaitée, occasion spéciale… (optionnel)
            </p>
          </div>

          <FormLabel className="sr-only">Message</FormLabel>
          <FormControl>
            <Textarea
              placeholder="Ex : C'est l'anniversaire de ma femme, j'aimerais quelque chose de romantique et raffiné…"
              className="resize-none bg-white rounded-xl border-2 focus:border-primary transition-colors min-h-[200px] font-p"
              {...field}
            />
          </FormControl>
          <FormMessage />

          <p className="text-xs text-muted-foreground">
            Ce message sera transmis directement à l&apos;équipe Hometoq pour personnaliser votre proposition.
          </p>
        </FormItem>
      )}
    />
  );
};
